/** Maximum delay supported by JavaScript timers across the runtimes we use. */
export const MAX_TYPING_DELAY_MS = 2_147_483_647;

export type TypingDelayChannel = 'other' | 'whatsapp';

export function clampTypingDelayMs(typingDelayMs: number | null | undefined): number {
  return Math.min(MAX_TYPING_DELAY_MS, Math.max(0, typingDelayMs ?? 0));
}

export function resolveTypingDelayMs(
  typingDelayMs: number | null | undefined,
  activeChannel: TypingDelayChannel | null | undefined
): number {
  return activeChannel === 'whatsapp' ? clampTypingDelayMs(typingDelayMs) : 0;
}
